import { getCredentials } from './auth';
import { createEventLog } from './create-event-log';
import { createPageViewLog } from './create-page-view-log';
import Analytics from 'analytics';
import awsPinpointPlugin from '@analytics/aws-pinpoint';
import { setPortalItemAccessPermissions } from './set-portal-item-access-permissions';
import { getPortalItemAccessPermissions } from './get-portal-item-access-permissions';
export class Amazon {
    constructor(options) {
        this.name = 'amazon';
        const { app = {}, fips, userPoolID } = options;
        this.analytics = Analytics({
            app: app.name,
            version: app.version,
            plugins: [
                awsPinpointPlugin({
                    fips,
                    pinpointAppId: app.id,
                    getCredentials: () => {
                        return getCredentials(userPoolID, { fips });
                    },
                }),
            ],
        });
        Object.assign(this, options);
    }
    init() {
        return Promise.resolve();
    }
    static async setAccessPermissions({ id, authentication, username, accessChangeset, }) {
        return setPortalItemAccessPermissions({
            id,
            authentication,
            username,
            accessChangeset,
        });
    }
    static async getAccessPermissions({ id, authentication, }) {
        return getPortalItemAccessPermissions({ id, authentication });
    }
    logPageView(page, options) {
        const telemetryPayload = createPageViewLog({
            page,
            previousPage: this.previousPage,
            options,
            dimensionLookup: this.dimensions,
            metricLookup: this.metrics,
        });
        const { pageUrl, pageName } = telemetryPayload;
        this.previousPage = { pageUrl, pageName };
        this.analytics.track('pageView', telemetryPayload);
    }
    logEvent(event = {}) {
        const telemetryPayload = createEventLog({
            event,
            dimensionLookup: this.dimensions,
            metricLookup: this.metrics,
        });
        const { name } = telemetryPayload;
        this.analytics.track(name, telemetryPayload);
    }
}
//# sourceMappingURL=index.js.map